import { events, IEventValues } from './jsonEvents';
import { Service } from '@models/Service/Service.interface';
import { ServiceGroup } from '@models/ServiceGroup/ServiceGroup.interface';

export const setMarksFromSubServices = (service: Service) => {
  if (
    service.subServices?.find(({ marks }) =>
      marks.find(({ code }) => code === 'new')
    ) &&
    !service.marks.find(({ code }) => code === 'new')
  ) {
    service.marks.push({ id: 1, title: 'Новое', code: 'new' });
  }

  return service;
};

export const setMarksFromSubServicesInGroup = (group: ServiceGroup) => {
  group.children?.forEach((service) => setMarksFromSubServices(service));

  return group;
};

export function filterObjectByArray(object: any, array: any[]): any {
  return Object.keys(object)
    .filter((key) => array.indexOf(parseInt(key)) !== -1)
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: object[key],
      };
    }, {});
}

export function isRootElement(id: number): boolean {
  const rootElements = [1, 2]; // 1 - biznes, 2 - uslugi
  return rootElements.indexOf(id) !== -1;
}

export function isIEDetect(): boolean {
  const ua = window.navigator.userAgent.toLowerCase();
  return /trident/gi.test(ua) || /msie/gi.test(ua);
}

export function getRootTitleByUrl(url: string): string {
  switch (url) {
    case '/uslugi':
      return 'Каталог услуг для жителей';
    case '/biznes':
      return 'Каталог услуг для бизнеса';
    default:
      return '';
  }
}

export function getRootTitle(id: number): string {
  switch (id) {
    case 1:
      return 'Каталог услуг для бизнеса';
    case 2:
      return 'Каталог услуг для жителей';
    default:
      return 'Популярное';
  }
}

export function getCookie(name: string) {
  const replaceFromName = /([.$?*|{}()[\]\\/+^])/;
  const reCookie = new RegExp(
    `(?:^|; )${name.replace(replaceFromName, '\\$1')}=([^;]*)`
  );
  const matches = document.cookie.match(reCookie);
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function getStatJSON(
  eventName: string,
  eventValues: IEventValues | undefined
) {
  if (!events[eventName]) return '';
  let resultJSON: string = events[eventName];
  for (let key in eventValues) {
    resultJSON = resultJSON.replace(`%${key}%`, eventValues[key].toString());
  }
  return resultJSON;
}
